import React from 'react';
import { useSelector } from 'react-redux';
import ThemableComponent from "./theme/ThemableComponent";

function CoronaHeader(props) {
    const showItinerary = useSelector(state => state.location.isItineraryShown);
    const showDashboard = useSelector(state => state.location.isDashboardShown);

    if(!showDashboard && !showItinerary) {
        return null;
    }


    return (
        <ThemableComponent componentName="CoronaHeader" showItinerary={showItinerary}/>
    );
}

export default CoronaHeader;


